const { BASE_URL } = require("./client");

const CONNECT_WITH_US = BASE_URL +'/api/connect/post'

module.exports = {
    CONNECT_WITH_US
}